import Vue from 'vue';
import Router from 'vue-router';
import ClassSelection from '@/components/classes/ClassSelection';
import StudentSelection from '@/components/students/StudentSelection';
import TestSelection from '@/components/tests/TestSelection';
import TestVerification from '@/components/tests/TestVerification';
import TestResult from '@/components/tests/TestResult';
import StartTest from '@/components/tests/StartTest';
import Home from '@/components/Home';
import Training from '@/components/Training';
import ResourcePage from '@/components/resources/ResourcePage';
import CooperativeLearningStage from '@/components/resources/CooperativeLearningStage';
import { flattenRoutes } from '@/data/resources';
import TestResultShare from '../components/tests/TestResultShare';

Vue.use(Router);

// One route per node in the Resources tree (src/data/resources.js).
const resourceRoutes = flattenRoutes().map(node => ({
  path: node.to,
  component: node.component === 'stage' ? CooperativeLearningStage : ResourcePage,
}));

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/training', component: Training },
    ...resourceRoutes,
    // Preserve the pre-restructure resource URLs.
    { path: '/resourcesprimary', redirect: '/resources/primary' },
    { path: '/resourcespostprimary', redirect: '/resources/post-primary' },
    { path: '/class/select', component: ClassSelection },
    { path: '/student/select', component: StudentSelection },
    { path: '/test/start', component: StartTest },
    { path: '/test/select', component: TestSelection },
    { path: '/test/result/:id', component: TestResult },
    { path: '/test/share/:id', component: TestResultShare },
    { path: '/test/verification', component: TestVerification },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js